import { red } from '../customColors'

export default function Alert (theme: any) {
  return {
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          padding: '20px 34px',
          '& .MuiAlert-message': {
            padding: 0
          }
        },
        standardError: {
          backgroundColor: 'rgba(230, 46, 46, 0.05)',
          '& .MuiAlert-message': {
            color: red[500]
          }
        }
      }
    }
  }
}
